import { render, staticRenderFns } from "./alert-http.vue?vue&type=template&id=bb428284&scoped=true"
import script from "./alert-http.vue?vue&type=script&lang=js"
export * from "./alert-http.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb428284",
  null
  
)

export default component.exports